/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { AuditLogAuthMethod } from '../models/AuditLogAuthMethod';
import { AuditLogAuthStatus } from '../models/AuditLogAuthStatus';
import { AuditLogMfaMethod } from '../models/AuditLogMfaMethod';

/**
* Authentication event details.
*/
export class AuditLogExtendedDataAuth {
  'status'?: AuditLogAuthStatus;
  'authMethod'?: AuditLogAuthMethod;
  /**
  * Whether MFA was required for this authentication.
  */
  'mfaRequired'?: boolean | null;
  'mfaMethod'?: AuditLogMfaMethod;
  /**
  * The result of the MFA challenge.
  */
  'mfaResult'?: string;
  /**
  * The reason for authentication failure, if applicable.
  */
  'failureReason'?: string;
  /**
  * The name of the identity provider used for SSO authentication.
  */
  'idpName'?: string;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "status",
      "baseName": "status",
      "type": "AuditLogAuthStatus",
      "format": ""
    },
    {
      "name": "authMethod",
      "baseName": "authMethod",
      "type": "AuditLogAuthMethod",
      "format": ""
    },
    {
      "name": "mfaRequired",
      "baseName": "mfaRequired",
      "type": "boolean",
      "format": ""
    },
    {
      "name": "mfaMethod",
      "baseName": "mfaMethod",
      "type": "AuditLogMfaMethod",
      "format": ""
    },
    {
      "name": "mfaResult",
      "baseName": "mfaResult",
      "type": "string",
      "format": ""
    },
    {
      "name": "failureReason",
      "baseName": "failureReason",
      "type": "string",
      "format": ""
    },
    {
      "name": "idpName",
      "baseName": "idpName",
      "type": "string",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return AuditLogExtendedDataAuth.attributeTypeMap;
  }

  public constructor() {
  }
}



